// extracted by mini-css-extract-plugin
module.exports = {"card":"Statements_card__MEP1y"};